import { render } from "./DmProfiles.vue?vue&type=template&id=327ee78e"
import script from "./DmProfiles.vue?vue&type=script&lang=js"
export * from "./DmProfiles.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__